/**
 * 上游节点内容检测工具（图像/视频/文本引导提示共用）。
 *
 * 这些函数无副作用、不依赖组件作用域，放在模块级以便在多个 guidance hook 间复用，
 * 同时避免在 useMemo 内反复创建闭包。
 */

/** 节点是否含有效图像内容（image 生成结果 / image upload 已上传）。 */
export function nodeHasImageContent(n: any): boolean {
  if (n?.type === 'image') {
    const viewMode = n.data?.viewMode;
    if (viewMode === 'primitive') return Boolean(n.data?.content?.url);
    if (viewMode === 'transform') return Boolean(n.data?.generated?.url);
    return Boolean(n.data?.generated?.url || n.data?.content?.url);
  }
  if (n?.type === 'upload') {
    const fileType = n.data?.fileType;
    const contentType = n.data?.content?.type as string | undefined;
    return Boolean(n.data?.content?.url) && (fileType === 'image' || Boolean(contentType?.startsWith('image/')));
  }
  return false;
}

/** 节点是否含有效视频内容（video 生成结果 / video upload 已上传）。 */
export function nodeHasVideoContent(n: any): boolean {
  if (n?.type === 'video') {
    const viewMode = n.data?.viewMode;
    if (viewMode === 'primitive') return Boolean(n.data?.content?.url);
    if (viewMode === 'transform') return Boolean(n.data?.generated?.url);
    return Boolean(n.data?.generated?.url || n.data?.content?.url);
  }
  if (n?.type === 'upload') {
    const fileType = n.data?.fileType;
    const contentType = n.data?.content?.type as string | undefined;
    return Boolean(n.data?.content?.url) && (fileType === 'video' || Boolean(contentType?.startsWith('video/')));
  }
  return false;
}

/** 节点是否含有效文本内容（text 节点输入或生成结果非空）。 */
export function nodeHasTextContent(n: any): boolean {
  if (n?.type !== 'text') return false;
  const viewMode = n.data?.viewMode;
  if (viewMode === 'primitive') return Boolean(n.data?.text?.trim());
  if (viewMode === 'transform') return Boolean(n.data?.generated?.text?.trim());
  return Boolean(n.data?.generated?.text?.trim() || n.data?.text?.trim());
}
